import React, { useState, useEffect } from 'react';
import {
  CForm,
  CRow,
  CCol,
  CInput,
  CCard,
  CContainer,
  CCardGroup,
  CCardBody,
  CAlert,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import LoaderButton from '../components/LoaderButton';
import axios from '../utils/axios';

const validationSchema = Yup.object({
  password: Yup.string().required('Required'),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Passwords must match'
  ),
});

function NewPassword(props) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [token, setToken] = useState();

  useEffect(() => {
    let params = queryString.parse(props.location.search);
    setToken(params.token);
  }, [props.location.search]);

  const { handleChange, handleSubmit, values, errors } = useFormik({
    initialValues: {
      confirmPassword: '',
      password: '',
    },
    validationSchema,
    async onSubmit(values) {
      try {
        setLoading(true);
        setErrorMessage(null);
        const response = await axios.post('/auth/reset-password', {
          password: values.password,
          code: token,
        });

        setLoading(false);
        if (response.status === 201) {
          setIsSuccess(response.data.description);
          history.push('/');
        }
      } catch (err) {
        setErrorMessage(
          err.response.data.message
            ? err.response.data.message
            : 'Something went wrong'
        );
        setLoading(false);
      }
    },
  });

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Reset Password</h1>
                    <CRow className="row-form">
                      <CCol sm="12" md="4">
                        <label className="text-swtich">New Password </label>
                      </CCol>
                      <CCol sm="12" md="6">
                        <CInput
                          label="id"
                          placeholder="Reset Password"
                          type="password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          invalid={errors.password ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="row-form">
                      <CCol sm="12" md="4">
                        <label className="text-swtich">Confirm Password </label>
                      </CCol>
                      <CCol sm="12" md="6">
                        <CInput
                          label="Email"
                          placeholder="Enter Code"
                          type="password"
                          name="confirmPassword"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          invalid={errors.confirmPassword ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="row-form">
                      <CCol sm="12" md="6">
                        <LoaderButton
                          title="Reset"
                          loading={loading}
                          onClick={handleSubmit}
                        />
                      </CCol>
                    </CRow>
                    {isSuccess && (
                      <CRow className="mt-3">
                        <CCol>
                          <CAlert color="success">{isSuccess}</CAlert>
                        </CCol>
                      </CRow>
                    )}
                    {errorMessage && (
                      <CRow className="mt-3">
                        <CCol>
                          <CAlert color="warning">{errorMessage}</CAlert>
                        </CCol>
                      </CRow>
                    )}
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
}

export default NewPassword;
